import utils from '../../../utils/utils.js';

export default {
  async fetchWorkspaceGroups(context, payload) {
    const pageNumber = payload.pageNumber;
    const pageSize = payload.pageSize;
    const sortColumn = payload.sortColumn;
    const sortDirection = payload.sortDirection;
    const searchText = payload.searchText;
    const responseData = await utils.utility.fetch(
      `api/Setting/GetWorkspaceGroups?pageNumber=${pageNumber}&pageSize=${pageSize}&sortColumn=${sortColumn}&sortDirection=${sortDirection}&searchText=${searchText}`,
      'GET',
      null,
      null
    );
    context.commit('setWorkspaceGroups', responseData.data);
  },
  async fetchGroupPermissions(context, payload) {
    const groupId = payload.groupId;
    const response = await utils.utility.fetch(
      `api/Setting/GetGroupPermissions?groupId=${groupId}`,
      'GET',
      null,
      null
    );

    context.commit('setGroupPermissions', response.data);
  },
  async fetchWorkspaceSocialMediaAccounts(context, payload) {
    const groupId = payload.groupId;
    const response = await utils.utility.fetch(
      `api/Setting/GetWorkspaceSocialMediaAccounts?groupId=${groupId}`,
      'GET',
      null,
      null
    );

    context.commit('setWorkspaceSocialMediaAccounts', response.data);
  },
  async fetchWorkspaceGroup(context, payload) {
    await utils.utility.fetch(
      `api/Setting/CreateWorkspaceGroup`,
      'POST',
      null,
      payload
    );
  },
  async postWorkspaceGroup(context, payload) {
    await utils.utility.fetch(
      `api/Setting/CreateWorkspaceGroup`,
      'POST',
      null,
      payload
    );
  },
  async putWorkspaceGroup(context, payload) {
    await utils.utility.fetch(
      `api/Setting/UpdateWorkspaceGroup`,
      'PUT',
      null,
      payload
    );
  },

  async deleteWorkspaceGroup(context, payload) {
    let postData = { groupID: payload.id };
    await utils.utility.fetch(
      `api/Setting/DeleteWorkspaceGroup`,
      'POST',
      null,
      postData
    );
  },
};
